import axios from 'axios'
import qs from 'query-string'
import store from '../store'
import { getToken } from '@/utils/auth'
import router from '@/router'
import {
  formatErrCode,
  showError,
  reportError,
  handleRequestError,
  handleReponseError
} from '@/utils/error'

// create axios instance
const service = axios.create({
  baseURL: '/api',
  timeout: 1000 * 60,
  paramsSerializer: function(params) {
    return qs.stringify(params)
  }
})

service.interceptors.request.use(config => {
  config.headers['X-CLIENT-ID'] = process.env.VUE_APP_CLIENT_ID
  return config
}, handleRequestError)

export function withInterceptor(instance) {
  // request interceptor
  instance.interceptors.request.use(config => {
    const token = getToken()
    if (token && !config.headers['Authorization']) {
      config.headers['Authorization'] = token
    }
    return config
  }, handleRequestError)

  // response interceptor
  // http error will be handled here, business error with non-zero code will be handed over to business processing
  instance.interceptors.response.use(response => {
    if (response.config.responseType === 'blob') {
      return response.data
    }

    const { code } = response.data

    if (code === 0) {
      return response.data
    }

    // no login
    if (code === 176) {
      store.commit('auth/FE_LOGOUT')
      if (router.app.$route.path !== '/login') {
        router.push('/login')
      }
    }

    const { noErrMsg = false, errMsg = {} } = response.config
    const errMap = formatErrCode(errMsg)
    const err = errMap[code] || errMap.default

    if (!noErrMsg && !!err.msg) {
      showError(err.msg, err.type)
    }

    if (code === 1 || !errMap[code]) {
      reportError(response.data, err.msg, {
        url: response.config.url,
        method: response.config.method,
        data: response.config.data
      })
    }

    return response.data
  }, handleReponseError)

  return instance
}

export default withInterceptor(service)
